import React, { ReactNode, useState } from 'react';
import {
  SettingsInlineButton,
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
} from '@views/Settings/components';
import { useDispatch } from 'react-redux';
import analytics from '@support/analytics';
import { apiRequest } from '@support/api';
import { alertUser } from '@actions/alerts';
import { LoaderIcon } from '@components/Icons';
import styles from './DataExport.module.scss';

export default function DataExport() {
  const [buttonContent, setButtonContent] = useState<ReactNode>('Export my data');
  const dispatch = useDispatch();

  const sendZapierEmail = () => {
    analytics.track('Account Export Requested');
    setButtonContent(
      <>
        Requesting data <LoaderIcon />
      </>,
    );
    apiRequest('GET', '/users/self/export/')
      .then(() => {
        setButtonContent('Data requested');
        dispatch(alertUser('Check your email in a few minutes', 'success'));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Section>
      <SettingsSectionLabel>My Data</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        Get my Clay data via email
        <SettingsInlineButton onClick={sendZapierEmail}>{buttonContent}</SettingsInlineButton>
        <p>
          Click above to request your Clay data, and we'll email you a copy of your contacts and
          notes. This may take a few minutes.
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
